import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "compare-table" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-hover" }
const _hoisted_4 = { class: "visually-hidden" }
const _hoisted_5 = { class: "table-light" }
const _hoisted_6 = {
  scope: "col",
  style: {"width":"50px"}
}
const _hoisted_7 = ["checked", "disabled"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["checked", "disabled", "onClick", "aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_11 = {
  key: 1,
  class: "selection-info",
  "aria-live": "polite"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("caption", _hoisted_4, " Projecten. Vink een project aan om het aan de vergelijking toe te voegen; er kunnen er maximaal " + _toDisplayString(_ctx.maxSelect) + " tegelijk vergeleken worden. ", 1),
        _createElementVNode("thead", _hoisted_5, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_6, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                checked: _ctx.allSelected,
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args))),
                disabled: _ctx.records.length === 0,
                "aria-label": "Alle zichtbare projecten selecteren"
              }, null, 40, _hoisted_7)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("th", { scope: "col" }, "#", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayFields, (field) => {
              return (_openBlock(), _createElementBlock("th", {
                scope: "col",
                key: field
              }, _toDisplayString(_ctx.getFieldLabel(field)), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (record, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: record.id,
              class: _normalizeClass(["selectable-row", { 'selected': _ctx.isSelected(record.id), 'disabled': _ctx.isDisabled(record.id) }]),
              onClick: ($event: any) => (_ctx.toggleRow(record.id))
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  checked: _ctx.isSelected(record.id),
                  disabled: _ctx.isDisabled(record.id),
                  onClick: _withModifiers(($event: any) => (_ctx.toggleRow(record.id)), ["stop"]),
                  "aria-label": 'Vergelijk ' + _ctx.recordNaam(record)
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayFields, (field) => {
                return (_openBlock(), _createElementBlock("td", { key: field }, _toDisplayString(_ctx.formatValue(record[field])), 1))
              }), 128))
            ], 10, _hoisted_8))
          }), 128))
        ])
      ])
    ]),
    (_ctx.records.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", {
            class: "fas fa-inbox",
            "aria-hidden": "true"
          }, null, -1),
          _createElementVNode("p", null, "Geen records gevonden", -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.selectedRecords.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.selectedRecords.length) + " van " + _toDisplayString(_ctx.maxSelect) + " geselecteerd voor vergelijking ", 1))
      : _createCommentVNode("", true)
  ]))
}